import React, { useEffect, useState } from "react";
import ExlyModal from "common/Components/ExlyModal";
import moduleStyle from "./PayoutModal.module.css";
import classnames from "classnames";
import { Checkbox, Button } from "@my-scoot/component-library-legacy";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import ExlyLoader from "ui/modules/ExlyLoader";
import constants from "constants/constants";
import { usePayment } from "features/AffiliateMarketing/utils/usePayment";
import { usePayoutModal } from "./utils/usePayoutModal";
import { useBankDetail } from "features/AffiliateMarketing/utils/useBankDetail";
import { useGetAffiliateUuid } from "features/AffiliateMarketing/utils/useGetAffiliateUuid";
import { roundOff } from "utils/Utils";
import { RUPEE_SYMBOL } from "features/Common/modules/Currency/constants/Currency.constants";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import { useWallets } from "features/Account/modules/Wallets/utils/useWallets";
import { getUserCurrencySymbol } from "utils/AuthUtil";
import { walletKeys } from "features/Account/modules/Wallets/constants/Wallets.constants";
import { roundOffIfDecimal } from "features/Common/modules/DataTypes/utils/numbers";

const PayoutModal = () => {
  const { initiatePayment, getTransactionInvoiceUrl } = usePayment();
  const { handleSendRemainder } = useBankDetail();
  const { affiliateUuid } = useGetAffiliateUuid();

  const {
    payoutData,
    processing,
    showAffiliatePayoutModal,
    showAffiliatePayoutErrorModal,
    handleShowAffiliatePayoutModal,
    handleShowAffiliatePayoutErrorModal,
  } = usePayoutModal();

  const isWalletActive = useWalletStore((state) => state.isWalletActive);
  const isPayViaWallet = useWalletStore((state) => state.isPayViaWallet);
  const setIsPayViaWallet = useWalletStore((state) => state.setIsPayViaWallet);
  const { walletBalance, walletDeductionCalc, refreshWalletBalance } =
    useWallets({
      isFetchWalletBalanceEnabled: true,
    });
  const [amount, setAmount] = useState();

  const handleWalletSelectionChange = (e) => {
    let isChecked = e?.target?.checked;
    setIsPayViaWallet(isChecked);
    let walletDeductionInfo = walletDeductionCalc({
      totalAmount: amount,
    });
    if (isChecked) {
      setAmount(walletDeductionInfo?.totalAmount);
    } else {
      setAmount(payoutData?.final_gateway_amount);
    }
  };

  useEffect(() => {
    setAmount(payoutData?.final_gateway_amount);
  }, [payoutData?.final_gateway_amount]);

  useEffect(() => {
    refreshWalletBalance();
  }, []);

  if (showAffiliatePayoutErrorModal) {
    return (
      <ExlyModal
        open={showAffiliatePayoutErrorModal}
        title="Pay Commission"
        onClose={() => handleShowAffiliatePayoutErrorModal(false)}
        onPrimaryBtnClick={() => handleSendRemainder(affiliateUuid)}
        showSecondaryBtn={true}
        primaryBtnText={processing ? "..." : "Send Reminder"}
        primaryBtnProps={{
          className: classnames(moduleStyle.sendRemainder),
        }}
        modal_props={{
          modalPaperClassName: moduleStyle.modalWrapper,
        }}
        className={`p-0`}
      >
        <div className={moduleStyle.container}>
          {processing ? (
            <ExlyLoader />
          ) : (
            <>
              <ExlyImage
                path={"assets/images/affiliates/bank.svg"}
                className={moduleStyle.payoutImg}
              />
              <span className={moduleStyle.heading}>
                Affiliate bank details not available!
              </span>
              <span className={moduleStyle.subHeading}>
                Affiliate has not added/updated their bank details.
              </span>
              <span className={moduleStyle.subHeading}>
                Please inform them to update it
              </span>
            </>
          )}
        </div>
      </ExlyModal>
    );
  }

  if (showAffiliatePayoutModal)
    return (
      <ExlyModal
        open={showAffiliatePayoutModal}
        title="Pay Commission"
        onClose={() => handleShowAffiliatePayoutModal(false)}
        onPrimaryBtnClick={() =>
          initiatePayment({
            requestId: payoutData?.request_id,
            closeModal: () => {
              handleShowAffiliatePayoutModal(false);
            },
          })
        }
        showSecondaryBtn={true}
        primaryBtnText={
          processing
            ? "..."
            : parseInt(amount)
            ? "Confirm"
            : `Confirm Wallet Debit of ${RUPEE_SYMBOL}${roundOffIfDecimal(
                payoutData?.final_gateway_amount,
                2
              )}`
        }
        primaryBtnProps={{
          className: classnames(moduleStyle.primaryBtn),
        }}
        modal_props={{
          modalPaperClassName: moduleStyle.modalWrapper,
        }}
        className={`p-0`}
      >
        {processing ? (
          <ExlyLoader />
        ) : (
          <>
            <div className={moduleStyle.container}>
              {" "}
              <ExlyImage
                path={"assets/images/affiliates/payout.svg"}
                className={moduleStyle.payoutImg}
              />
              <div
                className={`d-flex align-items-center ${moduleStyle.heading}`}
              >
                <span>{`Pay Affiliate Commission of ${
                  constants.CURRENCY_SYMBOL_MAP[payoutData.currency] ||
                  RUPEE_SYMBOL
                } ${roundOff(
                  parseInt(amount) ? amount : payoutData?.final_gateway_amount,
                  2
                )}`}</span>
              </div>
              <span className={moduleStyle.subHeading}>
                The commissions will get transferred to the affiliate&apos;s
                bank account
              </span>
              <div className={moduleStyle.buttons}>
                <Button
                  color="link"
                  className={moduleStyle.secondaryButton}
                  buttonWrapperClassName={moduleStyle.buttonWrapperClassName}
                  variant="text"
                  onClick={() =>
                    getTransactionInvoiceUrl({
                      affiliateUuid,
                      payoutAmount: payoutData.affiliate_payout_amount,
                    })
                  }
                >
                  <div className={`d-flex align-items-center`}>
                    <VisibilityOutlinedIcon className={moduleStyle.icons} />
                    <div>View Invoice</div>
                  </div>
                </Button>
              </div>
            </div>
            {isWalletActive && (
              <>
                <div className="tw-flex tw-items-center tw-justify-between tw-leading-[14.32px] tw-py-[10px] tw-px-[24px] tw-text-black tw-w-full tw-bg-[#F2F0FF] tw-border-[#DFDCFA] tw-border-x tw-border-y-0 tw-border-solid">
                  <span className="tw-text-[14px] tw-flex tw-items-end tw-gap-[5px]">
                    <Checkbox
                      size="large"
                      wrapperClassName="!tw-border-[1.5px] !tw-border-solid !tw-border-[#493AB1]"
                      disabled={
                        walletBalance?.[walletKeys.walletBalance] ? false : true
                      }
                      checked={isPayViaWallet}
                      onChange={handleWalletSelectionChange}
                    />
                    <div className="tw-flex tw-gap-[5px]">
                      <span className="tw-font-medium tw-text-[14px]">
                        Use Exly Wallet balance
                      </span>
                      <span className="!tw-font-normal tw-text-[#27252299] tw-text-[12px]">
                        {"("}Current balance:{" "}
                        {`${getUserCurrencySymbol()}${
                          walletBalance?.[walletKeys.walletBalance]
                        }`}
                        {")"}
                      </span>
                    </div>
                  </span>
                  {/* uncomment when top up will be enabled */}
                  {/* {payoutData?.final_gateway_amount >
                  walletBalance?.[walletKeys.walletBalance] ? (
                    <Button
                      color="link"
                      size="small"
                      className="!tw-bg-transparent !tw-h-[14px] !tw-underline"
                      onClick={handleTopUpWalletClick}
                    >
                      <span className="!tw-text-[14px] tw-text-[#493AB1]">
                        Top-up wallet
                      </span>
                    </Button>
                  ) : null} */}
                </div>
              </>
            )}
          </>
        )}
      </ExlyModal>
    );

  return null;
};

export default PayoutModal;
